module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; __append("\r\n\r\n")
    ;  var u = require('util/Util.js').default;

    var showButtonDiv = 'hide';
    if (buttons === 'bottom') {
        showButtonDiv = '';
    }
    var w=u.extractNum(width);
    var h=u.extractNum(height);

    //Take into account the resizing handles
    var t = top - 4;

    ; __append("\r\n<div id=\"")
    ; __append(escapeFn( id ))
    ; __append("\" class=\"pf-control has-menu\" tabindex=\"")
    ; __append(escapeFn( tabIndex ))
    ; __append("\" draggable=\"true\" style=\"left:")
    ; __append(escapeFn( left ))
    ; __append("px; top:")
    ; __append(escapeFn( t ))
    ; __append("px; z-index:")
    ; __append(escapeFn( zOrder ))
    ; __append("; \">\r\n\r\n    <div class=\"size-handle-top\"    style=\"position:relative;\"></div>\r\n    <div class=\"size-handle-left\"   style=\"position: absolute; left: -2px;\"></div>\r\n\r\n    <div class=\"pf-control-core pf-selectable\">\r\n        <table id=\"grid_")
    ; __append(escapeFn( id ))
    ; __append("\"></table>\r\n        <div class=\"table-footer ")
    ; __append(escapeFn( showButtonDiv ))
    ; __append("\"  style=\"width: ")
    ; __append(escapeFn( w ))
    ; __append("px;\">\r\n\r\n            <button id=\"table_button_new\" type=\"button\"  class=\"btn btn-default hvr-glow tbl-icon no-box tbl-icon-data-lst\" style=\" cursor: default !important;\">\r\n                <i class=\"fa pf-add\" style=\"\"></i>\r\n            </button>\r\n            <button  id=\"table_button_new\" type=\"button\" name=\"itemRemove\" title=\"Remove Column\"\r\n                     class=\"btn btn-default hvr-glow itemRemove tbl-icon no-box tbl-icon-data-lst\" style=\" cursor: default !important;\">\r\n                <i class=\"fa pf-delete icon-gradient\"></i>\r\n            </button>\r\n        </div>\r\n    </div>\r\n\r\n    <div class=\"size-handle-right\"  style=\"height: ")
    ; __append(escapeFn( h +10))
    ; __append("px; right: 0;\"></div>\r\n    <div class=\"size-handle-bottom\" style=\"width:  ")
    ; __append(escapeFn( w ))
    ; __append("px;\"></div>\r\n\r\n</div>")
  }
  return __output;

}